(function () {
  var MOBILE_MAX = 749;

  function init() {
    if (window.matchMedia('(min-width: ' + (MOBILE_MAX + 1) + 'px)').matches) return;

    var productWrapper = document.querySelector('.product:not(.featured-product)');
    if (!productWrapper) return;

    var originalBtn = productWrapper.querySelector('.product-form__submit');
    if (!originalBtn) return;

    if (document.querySelector('.sticky-atc-bar')) return;

    var bar = document.createElement('div');
    bar.className = 'sticky-atc-bar';

    var clone = originalBtn.cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('type', 'button');
    clone.setAttribute('aria-label', 'Add to cart');

    clone.addEventListener('click', function (e) {
      e.preventDefault();
      if (originalBtn.disabled) return;
      originalBtn.click();
    });

    bar.appendChild(clone);
    document.body.appendChild(bar);
    document.body.classList.add('has-sticky-atc');

    var sync = function () {
      clone.disabled = originalBtn.disabled;
      clone.classList.toggle('loading', originalBtn.classList.contains('loading'));
      var srcText = originalBtn.querySelector('span');
      var dstText = clone.querySelector('span');
      if (srcText && dstText && srcText.textContent !== dstText.textContent) {
        dstText.textContent = srcText.textContent;
      }
    };

    var observer = new MutationObserver(sync);
    observer.observe(originalBtn, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    sync();

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('sticky-atc-bar--hidden', entry.isIntersecting);
          });
        },
        { threshold: 0.1 }
      );
      visibilityObserver.observe(originalBtn);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
